<script lang="ts" setup>
import { i18n } from '@/i18n';

defineProps<{
  value?: number;
  minWidth?: string;
  width?: string;
  options: string[];
}>();

const t = i18n.t;

const emits = defineEmits<{
  (e: 'mouseover'): void;
  (e: 'mouseleave'): void;
  (e: 'clickSuggest', suggest: string): void;
}>();
</script>

<template>
  <div id="suggest-container" class="suggest-container" @mouseover="emits('mouseover')" @mouseleave="emits('mouseleave')">
    <ul class="suggest-container__list">
      <li v-for="(suggest, index) in options" :key="index" class="suggest-container__item" @click="emits('clickSuggest', suggest)">
        <!-- 「選択を外す」用の表示分けを行うための分岐 -->
        <template v-if="suggest === 'UNSELECTED_HEADER_VALUE'">
          {{ t(suggest) }}
        </template>
        <template v-else>
          {{ suggest }}
        </template>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.suggest-container {
  position: absolute;
  top: 100%;
  background-color: $backgroundOver;
  max-height: 300px;
  overflow-y: scroll;
  display: flex;
  justify-content: start;
  min-width: v-bind('minWidth ?? "64px"') !important;
  max-width: v-bind('width ?? "64px"') !important;
  &__list {
    margin-left: 0;
    margin-right: 0;
    list-style-type: none;
    text-align: left;
    cursor: pointer;
  }
  &__item {
    width: v-bind('minWidth ?? "100%"');
    display: block;
    &:hover {
      background-color: $optionalLightBlue;
    }
  }
}
</style>
